import type { ScaleQuality } from '@theory/keys';
import styles from './KeyChip.module.css';

interface KeyChipProps {
  rootNote: string;
  quality: ScaleQuality;
  state?: 'default' | 'muted' | 'selected';
  onClick?: () => void;
}

export function KeyChip({ rootNote, quality, state = 'default', onClick }: KeyChipProps) {
  const muted = state === 'muted';
  const selected = state === 'selected';
  const display = quality === 'minor' ? `${rootNote}m` : rootNote;
  return (
    <button
      type="button"
      className={[styles.chip, muted && styles.muted].filter(Boolean).join(' ')}
      onClick={muted ? undefined : onClick}
      aria-pressed={selected}
      aria-disabled={muted || undefined}
      aria-label={`${rootNote} ${quality}`}
    >
      <span className={styles.label}>{display}</span>
      <span className={styles.sub}>{quality}</span>
    </button>
  );
}
